export const CREDIT_EXHAUSTION_EVENT = "tribunalea:credits-exhausted";

export function isCreditExhaustionPayload(payload) {
  if (!payload || typeof payload !== "object") return false;
  // `awaiting_credits` is also returned by passive status endpoints. Those
  // states have an inline UI; reserve the global modal for a failed action.
  if (payload.code === "insufficient_credits") return true;
  return (
    isCreditExhaustionPayload(payload.error) ||
    isCreditExhaustionPayload(payload.data) ||
    isCreditExhaustionPayload(payload.access) ||
    isCreditExhaustionPayload(payload.billing)
  );
}

export function notifyCreditExhaustion(payload) {
  if (!isCreditExhaustionPayload(payload)) return false;
  if (
    typeof window !== "undefined" &&
    typeof window.dispatchEvent === "function"
  ) {
    window.dispatchEvent(new CustomEvent(CREDIT_EXHAUSTION_EVENT));
  }
  return true;
}
